import { SubscriptionUserInfo } from "../../model";
import apiService from "../ApiService";
import { map } from "rxjs";

export declare type VerifyRedeemCodeOpt = {
  redemptionCode: string;
  organization: string;
};
export const verifyRedeemCode = ({
  redemptionCode,
  organization,
}: VerifyRedeemCodeOpt) => {
  return apiService
    .get<{ userInfo: SubscriptionUserInfo } | Record<string, never>>({
      path: `v1/partner/verify`,
      params: {
        redemptionCode,
        organization,
      },
    })
    .pipe(map((e) => ("userInfo" in e ? e.userInfo : undefined)));
};
